import { ReportFeatures } from '@hcs/types';

export const DAYS_ON_MARKET_CHART_FEATURES = [ReportFeatures.DaysOnMarketChart];
